import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.sections = this.linkTargets
      .map((link) => document.getElementById(link.dataset.section))
      .filter(Boolean)

    if (this.sections.length === 0) return

    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      { rootMargin: "-20% 0px -70% 0px", threshold: 0 }
    )
    this.sections.forEach((section) => this.observer.observe(section))
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.setActive(entry.target.id)
      }
    })
  }

  setActive(id) {
    this.linkTargets.forEach((link) => {
      link.classList.toggle("is-active", link.dataset.section === id)
    })
  }

  copyLink(event) {
    const button = event.currentTarget
    navigator.clipboard.writeText(window.location.href).then(() => {
      const original = button.innerHTML
      button.innerHTML = '<svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"/></svg>'
      setTimeout(() => { button.innerHTML = original }, 1500)
    })
  }
}
